export default {"src":"/_next/static/image/public/images/icons/icon-warning.15032c776c907907e21a1d69a7058bca.svg","height":14,"width":16};